import React from "react";
import { useMenuActive } from "src/hooks/menu";
import Text from "src/components/ui/text";
import { Button } from "src/components/ui/button";

export interface ChipMenuItemProps {
  to: string;
  title: string;
  level: 1 | 2 | 3 | 4 | 5;
  style?: React.CSSProperties;
}

const ChipMenuItem: React.FC<ChipMenuItemProps> = ({ to, level, title, style }) => {
  const isActive = useMenuActive(to, level);
  return (
    <Text.Link to={to}>
      <Button size="sm" variant={isActive ? "primary" : "outline"} className="px-4 py-2 rounded-md text-sm tracking-normal">
        {title}
      </Button>
    </Text.Link>
  );
};

export default ChipMenuItem;
